import { Phone, Mail, MapPin, Heart, Users, BookOpen } from "lucide-react";
import heroBg from "../assets/bg/bg-hero-3.webp";

const donationAmounts = [500, 1000, 2500, 5000, 10000];

export default function Contact() {
  return (
    <div>
      <div className="page-hero"
      style={{
  backgroundImage: `linear-gradient(rgba(17,29,24,0.78), rgba(17,29,24,0.78)), url(${heroBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
}}
      >
        <div className="container"
         
        >
          <span className="eyebrow" style={{ color: "var(--gold-light)" }}>Get Involved</span>
          <h1 className="display-lg" style={{ marginTop: "0.5rem", marginBottom: "0.75rem" }}>Donate & Contact Us</h1>
          <p>Every contribution, big or small, changes a child's life. Join hands with BCCF today.</p>
        </div>
      </div>
      <div className="ribbon-divider" />

      <section className="section">
        <div className="container">
          <div className="grid-2" style={{ gap: "3rem" }}>
            {/* Donation Panel */}
            <div>
              <span className="eyebrow" style={{ marginBottom: "0.75rem", display: "block" }}>Make a Donation</span>
              <h2 className="display-md" style={{ marginBottom: "1.25rem" }}>
                Your Gift<br /><em style={{ color: "var(--forest-mid)" }}>Changes Everything.</em>
              </h2>
              <p style={{ color: "var(--gray)", marginBottom: "2rem", lineHeight: 1.75 }}>
                Your donation provides school fees, books, uniforms, meals, and mentoring to children who need it most. 
              </p>

              {/* What your donation does */}
              <div style={{ marginBottom: "2rem" }}>
                {[
                  [Heart, "₹500/month", "Sponsors a child's full education for a year"],
                  [BookOpen, "₹1,000/month", "Covers 2 children's books + school fees"],
                  [Users, "₹5,000/month", "Funds an entire classroom's stationery"],
                ].map(([Icon, amount, desc], i) => (
                  <div key={i} style={{ display: "flex", gap: "1rem", alignItems: "center", padding: "1rem", borderRadius: 12, marginBottom: "0.75rem", background: "var(--cream-dark)" }}>
                    <div style={{ width: 44, height: 44, borderRadius: "50%", background: "var(--forest)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon size={18} color="var(--gold)" />
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, color: "var(--forest)", fontFamily: "var(--font-label)" }}>{amount}</div>
                      <div style={{ fontSize: "0.88rem", color: "var(--gray)" }}>{desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              
            </div>

            {/* Contact Info */}
            <div>
              <span className="eyebrow" style={{ marginBottom: "0.75rem", display: "block" }}>Reach Us</span>
              <h2 className="display-md" style={{ marginBottom: "1.25rem" }}>Get In Touch</h2>
              <p style={{ color: "var(--gray)", marginBottom: "2rem", lineHeight: 1.75 }}>
                Have questions about BCCF, our programmes, volunteering, or donations? We'd love to hear from you.
              </p>

              {[
                [MapPin, "Our Address", "596/3 M.B. Road, (Banik More), Birati, North 24 parganas, Kol- 700051, West Bengal, India"],
                [Phone, "Phone", "+91 98300 19844"],
                [Mail, "Email", "biratichildcarefoundation@gmail.com"],
              ].map(([Icon, label, value], i) => (
                <div key={i} style={{ display: "flex", gap: "1.25rem", marginBottom: "1.75rem" }}>
                  <div style={{ width: 52, height: 52, borderRadius: 14, background: "rgba(27,67,50,0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Icon size={22} color="var(--forest)" />
                  </div>
                  <div>
                    <div style={{ fontFamily: "var(--font-label)", fontWeight: 700, fontSize: "0.82rem", letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--gray)", marginBottom: "0.25rem" }}>{label}</div>
                    <div style={{ color: "var(--charcoal)", lineHeight: 1.6, fontSize: "0.95rem", whiteSpace: "pre-line" }}>{value}</div>
                  </div>
                </div>
              ))}

              {/* Bank Details */}
              <div style={{ background: "var(--forest)", borderRadius: "var(--radius)", padding: "1.75rem", color: "var(--white)", marginBottom: "1.5rem" }}>
                <h4 style={{ fontFamily: "var(--font-label)", fontSize: "0.82rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--gold)", marginBottom: "1rem" }}>Direct Bank Transfer</h4>
                {[
                  ["Account Name", "Birati Child Care Foundation"],
                  ["Account No.", "2967020000058"],
                  ["IFSC Code", "BARBOBIRATI"],
                  ["Bank", "Bank of Baroda, Birati Branch"],
                ].map(([l, v]) => (
                  <div key={l} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.88rem", marginBottom: "0.5rem", flexWrap: "wrap", gap: "0.25rem" }}>
                    <span style={{ color: "rgba(255,255,255,0.6)" }}>{l}</span>
                    <span style={{ fontWeight: 600 }}>{v}</span>
                  </div>
                ))}
              </div>

              

              {/* Volunteer CTA */}
              <div style={{ border: "2px solid var(--gold)", borderRadius: "var(--radius)", padding: "1.5rem" }}>
                <h4 style={{ fontFamily: "var(--font-display)", fontSize: "1.1rem", marginBottom: "0.5rem" }}>Become a Volunteer</h4>
                <p style={{ color: "var(--gray)", fontSize: "0.88rem", lineHeight: 1.7, marginBottom: "1rem" }}>
                  Donate your time and skills — teach a class, mentor a child, help with admin, or assist at our events.
                </p>
               <button
  className="btn btn-outline"
  style={{ borderColor: "var(--gold)", color: "var(--gold)" }}
  onClick={() => {
    window.open(
      "https://wa.me/919830019844?text=Hello,%20I%20want%20to%20apply%20as%20a%20volunteer",
      "_blank"
    );
  }}
>
  Apply as Volunteer
</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
